import { _ as i } from "./_asciiWords.js";
import { _ as s } from "./_hasUnicodeWord.js";
import { t as a } from "./toString.js";
import { _ as m } from "./_unicodeWords.js";
var c = i, e = s, f = a, _ = m;
function u(o, r, d) {
  return o = f(o), r = d ? void 0 : r, r === void 0 ? e(o) ? _(o) : c(o) : o.match(r) || [];
}
var w = u;
export {
  w
};
//# sourceMappingURL=words.js.map
